import React from 'react';
import { Link } from 'react-router-dom';

const AdminDashboard = () => {
  return (
    <div className="min-h-screen bg-gray-50 px-6 py-16">
      <div className="max-w-5xl mx-auto">
        <div className="bg-white border border-gray-200 shadow-[0_10px_30px_rgba(0,0,0,0.06)] rounded-2xl p-8">
          <div className="flex flex-col gap-6 sm:flex-row sm:items-center sm:justify-between">
            <div>
              <h1 className="text-2xl font-semibold tracking-tight text-black">Admin Dashboard</h1>
              <p className="mt-2 text-sm text-gray-600">Manage products and site content.</p>
            </div>
            <div className="flex gap-3">
              <Link
                to="/home"
                className="rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-black hover:bg-gray-50 transition-colors"
              >
                View Website
              </Link>
            </div>
          </div>

          <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="rounded-xl border border-gray-200 p-5">
              <div className="text-sm font-medium text-black">Products</div>
              <div className="mt-1 text-sm text-gray-600">Create, edit, delete products, and manage stock.</div>
            </div>
            <div className="rounded-xl border border-gray-200 p-5">
              <div className="text-sm font-medium text-black">Home Content</div>
              <div className="mt-1 text-sm text-gray-600">Edit banners, featured collections, and site highlights.</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
